/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Paths from '@fai/friendli-suite/features/routes/paths';
import { hideOptionFromRelease } from '@fai/friendli-suite/shared/environments/hide-from-release';
import DEProjectSubLayout from '@fai/friendli-suite/views/layout/product/dedicated-endpoints/projects/sub-layout';
import { NavigationTabs } from '@fai/ui/components/tabs/navigation-tabs';

import ModelDetailHeader from './model-detail-header';

export default function ProjectModelDetailLayout() {
  const { t } = useTranslation();
  const { teamId = '', projectId = '', modelId = '' } = useParams();

  const basePath = Paths.team(teamId)
    .dedicatedEndpoints.project.detail(projectId)
    .model.detail(modelId);

  const tabValues: ComponentProps<typeof NavigationTabs>['values'] = [
    {
      label: t('dedicated_endpoints.project.overview'),
      path: basePath.overview,
    },
    ...hideOptionFromRelease({
      label: t('dedicated_endpoints.project.versions'),
      path: basePath.versions,
    }),
    {
      label: t('dedicated_endpoints.project.endpoints_tab'),
      path: basePath.endpoints,
    },
    {
      label: t('dedicated_endpoints.project.files'),
      path: basePath.files,
    },
  ];

  return (
    <DEProjectSubLayout
      headerSlot={<ModelDetailHeader />}
      tabSlot={<NavigationTabs values={tabValues} preventScrollReset={true} />}
    />
  );
}
